export default __webpack_public_path__ + "static/media/Days_05.9638069a.png";